import Alpine from "alpinejs";
import swipeEvents from "./SwipeEvents";

Alpine.data("slider", (skip) => ({
    index: 0,
    onStart: true,
    onEnd: true,
    itemWidth: 0,
    containerWith: 0,
    totalWidth: 0,
    maxIndex: 0,
    noSlider: true,
    get current() {
        return this.index;
    },
    set current(index) {
        this.slide(this.itemWidth * index);
        this.setIndex();
    },
    init() {
        // Set the maximal index
        this.maxIndex = this.$refs.slider.childElementCount - 1;
        this.checkWidth();
        this.setIndex();
        swipeEvents(this.$refs.slider, { mouse: true });
    },
    checkWidth() {
        const slider = this.$refs.slider;
        // Get the width of the container
        this.containerWith = slider.getBoundingClientRect().width;
        // Get the width of a single item
        this.itemWidth = slider.firstElementChild.getBoundingClientRect().width;
        // Get the total width of all items
        this.totalWidth = (this.maxIndex + 1) * this.itemWidth;
        // Check if the slider is needed
        this.noSlider = this.containerWith >= this.totalWidth;
    },
    slider: {
        "@swiped"({ detail }) {
            let numberOfSlides = Math.max(Math.round(detail.distance / this.itemWidth), 1);
            if (detail.direction === "right") {
                numberOfSlides = -numberOfSlides;
            }
            this.to((current, itemWidth) => current + itemWidth * numberOfSlides);
        },
        "x-id"() {
            return ["slider-label", "slider-content-label"];
        },
        ":aria-labelledby"() {
            return this.$id("slider-label");
        },
        "@touchend.passive"() {
            // Update index on touch end
            this.setIndex();
        },
        "@scroll.passive"() {
            // Update index on scroll
            this.setIndex();
        },
        "@keydown.left"() {
            this.prev();
        },
        "@keydown.right"() {
            this.next();
        },
        "@resize.window.passive.throttle"() {
            // Update on resize
            this.checkWidth();
            this.setIndex();
        },
        "@resize.window.passive.debounce"() {
            // Update on resize finished
            this.checkWidth();
            this.slide(this.index * this.itemWidth);
            this.setIndex();
        },
    },
    item: (index, isLast) => ({
        "x-intersect:enter"() {
            // Activate all buttons and links
            [...this.$el.querySelectorAll("button, a")].forEach((element) => {
                element.removeAttribute("tabindex");
            });

            // Preload next image
            [...this.$el.nextElementSibling.querySelectorAll("img")].forEach((element) => {
                element.classList.add("lazypreload");
            });
        },
        "x-intersect:leave"() {
            // Deactivate all buttons and links
            [...this.$el.querySelectorAll("button, a")].forEach((element) => {
                element.setAttribute("tabindex", "-1");
            });
        },
        "x-intersect:enter.full"() {
            // It is the first item
            if (index === 0) {
                this.onStart = true;
            }
            // It is the last item
            if (isLast) {
                this.onEnd = true;
            }
        },
        "x-intersect:leave.full"() {
            // It is the first item
            if (index === 0) {
                this.onStart = false;
            }
            // It is the last item
            if (isLast) {
                this.onEnd = false;
            }
        },
        "@mouseenter"() {
            this.notify(index);
        },
        "@focusin"() {
            this.notify(index);
        },
    }),

    notify(hover) {
        // Dispatch event on index change and hover
        const slider = this.$refs.slider;
        this.$dispatch("notify", {
            index: this.index,
            hover,
            onStart: this.onStart,
            onEnd: this.onEnd,
            maxIndex: this.maxIndex,
            slider: slider,
            slide: slider.children[hover != undefined ? hover : this.index],
        });
    },
    setIndex() {
        // If no slider is needed set values directly
        if (this.noSlider) {
            this.index = 0;
            this.notify();
            return;
        }

        // Wait for the slider to be ready (scrolling ended)
        setTimeout(() => {
            const current = this.$refs.slider.scrollLeft;
            this.index = Math.round(current / this.itemWidth);
            this.notify();
        }, 500);
    },
    next() {
        this.to((current, offset) => current + offset * skip);
    },
    prev() {
        this.to((current, offset) => current - offset * skip);
    },
    to(strategy) {
        const current = this.$refs.slider.scrollLeft;
        const left = strategy(current, this.itemWidth);
        this.slide(left);
        this.setIndex();
    },
    slide(left) {
        this.$refs.slider.scrollTo({ left, behavior: "smooth" });
    },
}));
